import { Button } from '@hologram-dimension/button';
import { EmptyState } from 'components';
import useOrganization from 'state/contexts/Organization/useOrganization';
import { SimsDaoSim } from 'types/__generated__/SimInventoryApi';
import useSimUrl from 'utils/hooks/useSimUrl';
import useAnalytics from 'state/contexts/Analytics/useAnalytics';
import type {
  CustomCellRendererProps,
  CustomCellRendererReturn,
  SimCellRendererProps,
} from '../SimInventoryTableShared';
import styles from './DeviceNameRenderer.module.css';

interface DeviceNameRendererProps
  extends CustomCellRendererProps<SimsDaoSim, SimCellRendererProps> {}

const DeviceNameRenderer = ({
  value,
  customProps,
}: DeviceNameRendererProps): CustomCellRendererReturn => {
  const { simDetailBaseUrl } = customProps;
  const orgId = useOrganization();
  const url = useSimUrl({ simDetailBaseUrl, orgId, simId: value.hologramSimId });
  const { sendAnalyticsEvent } = useAnalytics();

  const handleAnalytics = () => {
    if (sendAnalyticsEvent)
      sendAnalyticsEvent('SIM name', {
        deviceName: value.deviceName,
      });
  };

  if (!value.hologramSimId || !orgId) {
    if (value.deviceName) {
      return value.deviceName;
    }
    return <EmptyState />;
  }

  if (!url) return <EmptyState />;

  return (
    <Button
      variant="tertiary"
      noPadding
      to={url}
      className={styles.wrapper}
      accessibleText={`${value.deviceName} details`}
      onClick={handleAnalytics}
    >
      {value.deviceName}
    </Button>
  );
};

export default DeviceNameRenderer;
